<template>
  <TextField placeholder="Label" v-model="localValue.label"> </TextField>
</template>

<script>
import mixin from "./form-builder.mixin.js";
export default {
  extends: mixin,
};
</script>

<style></style>
